import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { can } from "@/lib/api";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import LedgerPage from "@/pages/LedgerPage";
import Masters from "@/pages/Masters";
import Reports from "@/pages/Reports";
import ImportPage from "@/pages/ImportPage";
import Users from "@/pages/Users";
import Approvals from "@/pages/Approvals";
import Accounts from "@/pages/Accounts";
import Parties from "@/pages/Parties";

function Protected() {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-slate-400 text-sm">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout />;
}

function Guard({ perm, children }) {
  const { user } = useAuth();
  return can(user, perm) ? children : <div className="text-slate-500 text-sm" data-testid="no-access">Aapke role ko is page ka access nahi hai.</div>;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Protected />}>
            <Route path="/" element={<Guard perm="dashboard"><Dashboard /></Guard>} />
            <Route path="/vi" element={<Guard perm="report:all"><LedgerPage ledger="vi" key="vi" /></Guard>} />
            <Route path="/dse" element={<Guard perm="report:limited"><LedgerPage ledger="dse" key="dse" /></Guard>} />
            <Route path="/fl" element={<Guard perm="report:limited"><LedgerPage ledger="fl" key="fl" /></Guard>} />
            <Route path="/cash" element={<Guard perm="report:all"><LedgerPage ledger="cash" key="cash" /></Guard>} />
            <Route path="/accounts" element={<Guard perm="report:all"><Accounts /></Guard>} />
            <Route path="/parties" element={<Guard perm="report:all"><Parties /></Guard>} />
            <Route path="/masters" element={<Masters />} />
            <Route path="/reports" element={<Guard perm="report:limited"><Reports /></Guard>} />
            <Route path="/import" element={<Guard perm="import:preview"><ImportPage /></Guard>} />
            <Route path="/approvals" element={<Guard perm="reversal:request"><Approvals /></Guard>} />
            <Route path="/users" element={<Guard perm="users:manage"><Users /></Guard>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}

export default App;
